import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import {
  MUNILY_SEGMENTED_CONTROL_DEFAULTS,
  SegmentedControlOption,
} from './segmented-control.types';

@Component({
  selector: 'common-segmented-control',
  templateUrl: './segmented-control.component.html',
  styleUrls: ['./segmented-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SegmentedControlComponent {
  @Input() value = MUNILY_SEGMENTED_CONTROL_DEFAULTS.value;
  @Input() options: SegmentedControlOption[] = [];
  @Output() valueChange = new EventEmitter<string>();

  trackOption(_: number, option: SegmentedControlOption): string {
    return option.value;
  }

  select(next: string): void {
    this.valueChange.emit(next);
  }
}
